export class HomeVideoComponent {
	video_first;
	video_second;
	video_playBtn;
	video_overlay;
	video_third;

	constructor() {
		this.video_first = document.querySelector('.video-first video');
		this.video_second = document.querySelector('.video-second video');
		this.video_playBtn = document.querySelector('.image__resources--play');
		this.video_overlay = document.querySelector('.image__resources');
		this.video_third = document.querySelector('.home-v2-managment__video-mobile video');
	}

	initialize() {
		this.overlay();
		if (!this.video_first && !this.video_second) {
			return;
		}
		this.addEventListeners();
	}

	overlay(){
		if(this.video_playBtn) {
			$('.home-v2-managment__video-mobile video').attr('playsinline','');
			this.video_playBtn.addEventListener('click', () => {
				this.video_overlay.classList.add('hidden');
				if (this.video_playBtn.classList.contains('hidden')) {
					this.video_third.pause();
					this.video_playBtn.classList.remove('hidden')
				} else {
					this.video_third.play();
					this.video_playBtn.classList.add('hidden');
				}
			});
		}
	}

	addEventListeners() {
		this.video_first.play();
		this.video_second.play();
		setTimeout(()=>{
			this.video_second.pause();
		}, 100)
		setTimeout(()=>{
			this.video_second.play();
			setTimeout(()=>{
				this.addEventListeners();
			}, 13400);
		}, 12000);
	}

}
